import { render } from "./UpdateTinInfoView.vue?vue&type=template&id=99a984be"
import script from "./UpdateTinInfoView.vue?vue&type=script&lang=js"
export * from "./UpdateTinInfoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__